<div>
    <admin-header></admin-header>
    <div class="ui container text-center margin-top-30 margin-bottom-50" >
        <h2 class="margin-top-30 margin-bottom-40">Liste des employés</h2>
        <div class="ui stackable grid">
            <div class="eight wide column">
                <admin-employee *ngFor="let employee of employees" [employee]="employee" (removing)="Remove($event)"></admin-employee>
            </div>
            <div class="eight wide column">
                <div class="ui left icon input">
                    <input type="text" placeholder="Nom" [(ngModel)]="employeeToAdd.name">
                    <i class="user icon"></i>
                </div>
                <div class="ui left icon input">
                    <input type="text" placeholder="Rôle" [(ngModel)]="employeeToAdd.job">
                    <i class="car icon"></i>
                </div>
                <web-picture-upload class="centered" (fileChosen)="pictureChosen($event)"></web-picture-upload>

                <button class="ui button margin-top-20 margin-bottom-50" (click)="addEmployee()">Ajouter</button>
            </div>
        </div>
    </div>
    <error-popup></error-popup>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/employees/employees.html